import actions from './actions';
import types from './constants';
import SRS from '../../../../services/StudentRecordService';
import { hasPendingAssessment } from '../../util/pendingAssessment';
import { generateSubscores } from '../../util/generators/generateSubscores';
import { fetchCurrentPeriod } from '../../../../services/query/calendarAPI';
import get from 'lodash.get';
import { getUserData } from 'Services/API';

const fetchReport = (classId, student, selectedPercentiles) => async (dispatch, getState) => {
  let studentId = null
  let grade = null
  if (student) studentId = student.value
  if (student) grade = student.grade

  const state = getState();
  const locale = get(state, 'reports.teacher.selectedLocale');
  const useARM = selectedPercentiles && selectedPercentiles.state !== "US";
  const {useLatestARM} = getUserData();
  
  // Convert locale format from "EN-US"/"ES-MX" to "EN_US"/"ES_MX" for generateSubscores
  const formattedLocale = locale === "EN-US" ? "EN_US" : locale === "ES-MX" ? "ES_MX" : locale;
  
  // Get additional parameters needed for generateSubscores
  const window = get(state, 'reports.teacher.selectedScreeningWindow', {});
  const { startDate, endDate } = window;
  const districtId = get(state, 'userData.district.id');
  const schoolId = get(state, 'reports.roster.ui.selections.school.id');
  
  // Determine period based on locale:
  // - Spanish: Use current period from calendaring service
  // - English: Use selected period from UI
  let period = get(state, 'reports.teacher.selectedScreeningWindow.id');
  if (formattedLocale === "ES_MX") {
    try {
      const currentPeriodResponse = await fetchCurrentPeriod({ schoolId: schoolId.toString() });
      const currentPeriod = currentPeriodResponse?.getCurrentPeriod?.periodIdentifier;
      if (currentPeriod) {
        period = currentPeriod;
        ({ startDate, endDate } = currentPeriodResponse);
      } else {
        console.warn("Could not get current period for Spanish, falling back to period selector value:", period);
      }
    } catch (error) {
      console.error("Error fetching current period for Spanish:", error);
      console.warn("Falling back to period selector value:", period);
    }
  }

  dispatch(actions[types.READINGROPE_PENDING]())
  try {
    let requests = [
      // Keep getting readingRope data for skill recommendations
      SRS.getReadingRopeData({ classId, studentId, useARM, locale, useLatestARM }),
      // Add subscores using generateSubscores function with formatted locale
      generateSubscores(classId, studentId, null, useARM, formattedLocale, useLatestARM, startDate, endDate, districtId, schoolId, grade, period)
    ]
    if(studentId){
      requests.push(hasPendingAssessment(studentId))
    }
    const [readingRopeData, subscores, isPending] = await Promise.all(requests);
    
    // Combine the data
    const combinedData = {
      ...readingRopeData,
      subscores,
      isPending: isPending || false
    };

    dispatch(actions[types.READINGROPE_COMPLETE](combinedData));
  }
  catch (e) {
    console.log("ERROR:",e)
    dispatch(actions[types.READINGROPE_ERROR](e))
  }
};

export default {
  fetchReport,
}